<template>
  <main>
    <Header />
    <div class="content">
      <ResetPasswordForm :token="theToken"/>
    </div>
    <Footer />
  </main>
</template>
<style>
</style>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ResetPasswordForm from "@/components/ResetPasswordForm.vue";

export default {
  name: "ResetPassword",
  title: "Reset your Dropsmart password",
  page: {
    title: "Password Reset",
    meta: [{ name: "description", content: "Password Reset" }],
  },
  components: {
    Header,
    Footer,
    ResetPasswordForm,
  },
  data() {
    return {
      theToken: this.token
    }
  },
  props: {
    token: {
      type: String,
    }
  },
};
</script>
